export default "/_next/static/chunks/fonts/Readex Pro ExtraLight-4fb35bcd4f4efbc7993dcc1241357199.ttf";